import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {endpoints, types} from 'main/tools';
import {redirect} from 'shared/tools';
import {policiesRootUrl} from 'main/containers/time_tracking/paths';

class OnboardingContainerState {
  store = new DomainStore();

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async createPolicy() {
    const {model} = await this.store.post(
      endpoints.TIME_TRACKING.POLICIES.ALL,
      types.TIME_TRACKING.POLICY
    );

    window.history.replaceState(null, null, policiesRootUrl());

    return redirect(`/time_tracking/policies/${model.id}/edit`);
  }
}

export default OnboardingContainerState;
